import { useTranslation } from 'react-i18next';
import { Icon } from '@/common/components/Icons/Icon';
import { PLAN } from '@/common/constants/markets';
import { TPlan } from '@/common/constants/markets';
import { ROUTES, routeFor } from '@/common/constants/routes';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useGetDiscounts } from '@/common/integrations/menhir/employee/discounts/discounts.hooks';
import { useAvailableBenefitCategories } from '@/web/hooks/benefits';
import { Route } from 'expo-router';
import { TabsWrapper } from './TabsWrapper/TabsWrapper';

export const ITTabsLayout = ({ plan }: { plan: TPlan }) => {
  switch (plan) {
    case PLAN.ITALY:
      return <ITItalyTabsLayout />;
    case PLAN.ITALY_FULL:
      return <ITItalyFullTabsLayout />;
    case PLAN.ITALY_FRINGE:
      return <ITItalyFringeTabsLayout />;
  }
};

function ITItalyTabsLayout() {
  const { discounts } = useGetDiscounts();
  const { t } = useTranslation();
  const {
    features: { ff_employee_coverflex_ai },
  } = useFeatures();

  return (
    <TabsWrapper
      items={[
        {
          href: ROUTES.ROOT,
          label: t('navigation.home'),
          icon: <Icon icon="home" />,
          exact: true,
        },
        {
          href: ROUTES.MEAL_VOUCHER,
          label: t('navigation.activity'),
          icon: <Icon icon="right-left" />,
        },
        {
          href: ROUTES.MEAL_NETWORK,
          label: t('navigation.meal_network'),
          icon: <Icon icon="location-dot" />,
        },
        {
          href: ROUTES.DISCOUNTS,
          label: t('navigation.discounts'),
          icon: <Icon icon="tags" />,
          hidden: discounts?.length === 0,
          sidebar: true,
        },
        {
          href: ROUTES.COVERFLEX_AI,
          label: t('navigation.coverflex_ai'),
          icon: <Icon icon="sparkles" />,
          hidden: !ff_employee_coverflex_ai,
          sidebar: true,
        },
        {
          href: ROUTES.PROFILE,
          label: t('navigation.profile'),
          icon: <Icon icon="user" />,
          sidebar: true,
        },
      ]}
    />
  );
}

function ITItalyFullTabsLayout() {
  const { meal, isInitialLoading } = useAvailableBenefitCategories();
  const { discounts } = useGetDiscounts();
  const {
    features: { ff_employee_coverflex_ai },
  } = useFeatures();
  const { t } = useTranslation();

  return (
    <TabsWrapper
      loading={isInitialLoading}
      items={[
        {
          href: ROUTES.ROOT,
          label: t('navigation.home'),
          icon: <Icon icon="home" />,
          exact: true,
        },
        {
          href: ROUTES.MEAL_VOUCHER,
          label: t('navigation.meal_voucher_card'),
          icon: <Icon icon="utensils" />,
          hidden: !meal,
        },
        {
          href: ROUTES.WELFARE,
          label: t('navigation.welfare'),
          icon: <Icon icon="seedling" />,
        },
        {
          href: ROUTES.MEAL_NETWORK,
          label: t('navigation.network'),
          icon: <Icon icon="location-dot" />,
          hidden: !meal,
        },
        {
          href: ROUTES.DISCOUNTS,
          label: t('navigation.discounts'),
          icon: <Icon icon="tags" />,
          hidden: discounts?.length === 0,
          sidebar: true,
        },
        {
          href: ROUTES.COVERFLEX_AI,
          label: t('navigation.coverflex_ai'),
          icon: <Icon icon="sparkles" />,
          hidden: !ff_employee_coverflex_ai,
          sidebar: true,
        },
        {
          href: ROUTES.PROFILE,
          label: t('navigation.profile'),
          icon: <Icon icon="user" />,
          sidebar: true,
        },
      ]}
    />
  );
}

function ITItalyFringeTabsLayout() {
  const { t } = useTranslation();
  const {
    features: { ff_employee_coverflex_ai },
  } = useFeatures();
  return (
    <TabsWrapper
      items={[
        {
          href: ROUTES.ROOT,
          label: t('navigation.home'),
          icon: <Icon icon="home" />,
          exact: true,
        },
        {
          href: routeFor(ROUTES.WELFARE_BENEFIT, 'fringe') as Route,
          label: t('navigation.activity'),
          icon: <Icon icon="right-left" />,
          exact: true,
        },
        {
          href: routeFor(ROUTES.WELFARE_CATEGORIES, 'fringe') as Route,
          label: t('navigation.categories'),
          icon: <Icon icon="location-dot" />,
        },
        {
          href: ROUTES.COVERFLEX_AI,
          label: t('navigation.coverflex_ai'),
          icon: <Icon icon="sparkles" />,
          hidden: !ff_employee_coverflex_ai,
          sidebar: true,
        },
        {
          href: ROUTES.PROFILE,
          label: t('navigation.profile'),
          icon: <Icon icon="user" />,
          sidebar: true,
        },
      ]}
    />
  );
}
